import type { SxProps, Theme } from "@mui/material/styles"
import type { ReactElement } from "react"
import React, { useMemo, useState } from "react"

import SearchSuggestion from "./index"

import { DEBOUNCE_DELAY_MS } from "@/constants/common"
import useCompetitorProducts from "@/screens/ManageProducts/components/CompetitorProducts/hooks/useCompetitorProducts"
import type { AutocompleteOption } from "@/types/form-fields"
import useDebounce from "@/utils/useDebounce"

const CompetitorProductSearchSuggestion = ({
  onSearch,
  sx,
}: {
  onSearch: (searchedItem: string | AutocompleteOption) => void
  sx?: SxProps<Theme>
}): ReactElement => {
  const [inputValue, setInputValue] = useState("")
  const debouncedSearchTerm = useDebounce(inputValue, DEBOUNCE_DELAY_MS)
  const { competitorProductsList, competitorProductsListFetching } = useCompetitorProducts({
    query: debouncedSearchTerm,
  })

  const options = useMemo(() => {
    if (competitorProductsListFetching) return []
    return (competitorProductsList?.map((product) => ({
      label: product.productName,
      id: product.competitorProductId,
    })) || []) as AutocompleteOption[]
  }, [competitorProductsList, competitorProductsListFetching])

  return (
    <SearchSuggestion
      onSearch={onSearch}
      placeholder='CAS#, Product Name or Chemical Name'
      inputValue={inputValue}
      setInputValue={setInputValue}
      options={options}
      fetching={competitorProductsListFetching}
      sx={sx}
    />
  )
}

export default CompetitorProductSearchSuggestion
